import { Col } from "components/grid/Col";
import { IgProfileContainer } from "components/person/Instagram";
import { SocialMediaInfo } from "components/person/partner/SocialMediaInfo";
import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";

class RedesSociais extends React.Component {

  render() {
    const{ partnerInfo } = this.props;
    if(!partnerInfo) return null;

    return (
      <div className={"p-2 p-lg-5"}>
        <Helmet>
          <title>Portal Glampartners: Redes Sociais</title>
        </Helmet>

        <h1>Redes Sociais</h1>
        <SocialMediaInfo />

      </div>
    );
  }

};

const mapStateToProps = (state) => {
  return {
    person: state.person.data,
    partnerInfo: state.partnerInfo.data
  }
}

const mapDispatchToProps = (dispatch) => { }

RedesSociais = connect(mapStateToProps, mapDispatchToProps)(RedesSociais);

export { RedesSociais }
